<div class="expanded-panel-header green" (click)="toggleExpand()">Project Dates</div>
@if(expanded){
  @for(row of rows; track $index){
    <div class="row" style="padding-left: 8px;padding-right: 8px;">
      @for(field of row; track field.key){
        <div class="col-md-6">
          <div class="row align-top" style="border-bottom: 1px solid lightgray">
            <div class="col-md-6 label">
              {{ field.label }}
              @if(field.key=='Placement Committee Reviewed' && dateDetail[field.key].milestoneDates.length>0){
                @for(date of dateDetail[field.key].milestoneDates; track $index){
                  <br/>
                  <small>{{date.date_type}}</small>
                }
              }
            </div>
              @if(dateDetail[field.key]){
                @if(field.key!=='Days Old' && field.key!=='Placement Committee Reviewed'){
                  <div class="col-md-6">
                    <span>
                    @if(dateDetail[field.key].is_target){
                      <i class="material-icons target-icon">my_location</i>
                    }
                      {{ dateDetail[field.key].value !==null ? (dateDetail[field.key].value | date : 'MM/dd/yyyy') : '--'}}</span>
                  </div>
                } @else if(field.key!=='Days Old' && field.key=='Placement Committee Reviewed') {
                  <div class="col-md-6">
                  {{ dateDetail[field.key].value !==null ? (dateDetail[field.key].value | date : 'MM/dd/yyyy') : '--'}}
                  @if(dateDetail[field.key].milestoneDates.length>0){
                    @for(date of dateDetail[field.key].milestoneDates; track $index){
                      <br />
                      <small>{{date.date | date: 'MM/dd/yyyy'}}</small>
                    }
                  }
                  </div>
                }  @else {
                  <div class="col-md-6">{{ dateDetail[field.key].value ?? '--'}}</div>
                }
              } @else if(field.key === 'LOI Expiration'){
                <div class="col-md-6">{{(detail.loi_expiration_date | date: 'MM/dd/yyyy') ?? '--'}}</div>
              }@else if(field.key === 'Added To Pipeline'){
                <div class="col-md-6">{{(detail.project_added  | date: 'MM/dd/yyyy') ?? '--'}}</div>
              }@else {
                <div class="col-md-6">--</div>
              }
          </div>
        </div>
      }
    </div>
  }
}
